import { render } from "./EnUnit1-2.vue?vue&type=template&id=298146e4&scoped=true"
import script from "./EnUnit1-2.vue?vue&type=script&lang=js"
export * from "./EnUnit1-2.vue?vue&type=script&lang=js"

import "../assets/css/en-common.css?vue&type=style&index=0&id=298146e4&scoped=true&lang=css"
import "../assets/css/en/Unit1-2.css?vue&type=style&index=1&id=298146e4&scoped=true&lang=css"
import "./EnUnit1-2.vue?vue&type=style&index=2&id=298146e4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298146e4"]])

export default __exports__